export default class Role {
  id?: number
  name?: string
  description?: string
  permissions: string[] = []
}